import { useEffect, useState } from "react";
import { navLinks } from "./navLinks";

export default function SiteNav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${
        scrolled
          ? "border-background-200 bg-background-50/95 backdrop-blur"
          : "border-transparent bg-background-50/70 backdrop-blur"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-4 md:px-6">
        <a href="#top" className="flex shrink-0 items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-gift-2-line text-lg" />
          </span>
          <span className="font-heading text-lg leading-none text-foreground-950">
            美味的快递
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="cursor-pointer whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-800"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden shrink-0 items-center gap-3 md:flex">
          <span className="flex items-center gap-1.5 text-xs text-foreground-600">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-calendar-schedule-line text-accent-600" />
            </span>
            下次开箱 10月14日
          </span>
          <a
            href="#tasting"
            className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            看试吃清单
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((prev) => !prev)}
          aria-label="打开菜单"
          aria-expanded={open}
          className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 md:hidden"
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
        </button>
      </div>

      {open ? (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <nav className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="cursor-pointer rounded-md px-3 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-800"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#tasting"
              onClick={() => setOpen(false)}
              className="mt-2 cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-3 py-2.5 text-center text-sm font-medium text-background-50"
            >
              看试吃清单
            </a>
          </nav>
        </div>
      ) : null}
    </header>
  );
}